export enum Breakpoints {
  Max = 1920,
  Mid = 1365,
  SemiMid = 900,
  Min = 667
}

export const cardResponsive = { xs: 24, sm: 24, md: 24, lg: 12, xl: 12 };
